import React, { useState } from "react";

import CalendarPage from "./../Components/Calendar/CalendarPage";

export default function ShiftCalendar() {
  return (
    <div className=" pl-6 mt-20 ">
      <CalendarPage />
    </div>
  );
}
